




import {Component, Prop, Vue} from "vue-property-decorator";
import {PostOfficeStore} from "../../store";

@Component({
    name: "PostOfficeLabel"
})
export default class extends Vue {
    @Prop({ required: true, type: String })
    readonly id!: string;

    get label() {
        return `${PostOfficeStore.data[this.id]?.postOfficeCode} - ${PostOfficeStore.data[this.id]?.name}`;
    }
}
